export const IconIfood = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <g clipPath="url(#IconIfood_svg__a)">
        <path d="M1 12.89h1.674l.93-4.778H1.93zm1.022-5.347h1.682l.276-1.43H2.3zm1.304 6.69H5l1.023-5.16H7.28l.185-.96H6.232l.047-.217c.07-.407.21-.864.837-.864.373 0 .721.024 1.07.192l.186-1.008A3.6 3.6 0 0 0 7.162 6c-1.348 0-2.278.816-2.627 2.112h-.581l-.186.96h.58z" />
        <path d="M8.628 12.985c1.977 0 3.349-1.848 3.349-3.36 0-1.129-1-1.609-1.977-1.609-2.163 0-3.349 1.994-3.349 3.36 0 1.13 1.024 1.61 1.977 1.61m5.303 0c1.976 0 3.349-1.848 3.349-3.36 0-1.129-1.024-1.609-2-1.609-2.163 0-3.35 1.993-3.35 3.36 0 1.13 1.047 1.61 2 1.61M20 12.89h1.65L23 6.097h-1.674l-.396 2.016-.697-.072c-1.628 0-3.117 2.16-3.117 3.697 0 .624.395 1.248 1.07 1.248.954 0 1.628-.48 1.907-.96h.092zm-5.164 3.577a6.33 6.33 0 0 1-4.65 1.512c-2.21-.144-3.792-1.897-4.07-3.745h.092c.512 1.154 1.744 2.233 3.256 2.4 1.534.193 3.372-.527 4.372-1.512l-1.116-.888h3.372l-.745 3.697-.488-1.44z" />
      </g>
      <defs>
        <clipPath id="IconIfood_svg__a">
          <path fill="#fff" d="M1 6h22v12H1z" />
        </clipPath>
      </defs>
    </svg>
  );
};
